import { APPS } from './constant.js';

export let appkey = localStorage.getItem('app') || Object.entries(APPS)[0][0];
export let apibase = localStorage.getItem('apibase') || Object.entries(APPS)[0][1].apibase;
export let apikey = localStorage.getItem('apikey') || '';
export let demoImages = localStorage.getItem('demo-images') || '';
export let resultCount = localStorage.getItem('result-count') || 36;

export function saveSettings(settings) {
  ({appkey, apibase, apikey, demoImages, resultCount} = settings);
  localStorage.setItem("app", appkey);
  localStorage.setItem('apibase', apibase);
  localStorage.setItem('apikey', apikey);
  localStorage.setItem("demo-images", demoImages);
  localStorage.setItem("result-count", resultCount);
}

export function setAPIInfo(info) {
  ({appkey, apibase, apikey} = info);
  localStorage.setItem('appkey', appkey);
  localStorage.setItem('apibase', apibase);
  localStorage.setItem('apikey', apikey);
}
